import {useEffect, useState} from "react";

function useGetGoodsEditDoc(editDoc, options, currentManBols) {

    const [valueGoodsEditDoc, setValueGoodsEditDoc] = useState([]);

    useEffect(() => {

        let isMount = true;

        if(editDoc === true && options.length !== 0) {
            const filteredCurrentManBols = currentManBols?.goods;
            const findCurrentManBols = [];
            filteredCurrentManBols?.forEach(item => {
                const findCurrentManBolsItem = options.find(el => el.value === item.bol.id)
                findCurrentManBols.push({...findCurrentManBolsItem, id: item.id, loading_order_id: item.loadingOrder.id, edit: true, loading_order_date: item.loadingOrder?.date})
            })
            isMount && setValueGoodsEditDoc(JSON.parse(JSON.stringify(findCurrentManBols).replaceAll('"value"', '"bol_id"')).sort((a, b) => a.bol_id - b.bol_id))
        }
       
        return () => {
            isMount = false;
        }
    },[editDoc, options, currentManBols])

    return {valueGoodsEditDoc};
}
export default useGetGoodsEditDoc;